import RecentActorsIcon from "@mui/icons-material/RecentActors";
import {
  convertToIndonesianTime,
  formatDisplayDate2,
  roundToTwoDecimals,
} from "Helper";
import { decryptNik } from "Config/cripto";

const BoxTarget = ({ item }) => {
  return (
    <div className="pb-1 sm:pb-2 mb-0.5 w-full">
      <div className="relative bg-black/20 rounded-md">
        {/* Border garis luar */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-[1%] z-10 w-full border-t border-red-500"></div>
          <div className="absolute top-[99%] z-10 w-full border-b border-red-500"></div>
          <div className="absolute left-[0.5%] z-10 h-full border-l border-red-500"></div>
          <div className="absolute left-[99.5%] z-10 h-full border-r border-red-500"></div>
        </div>

        {/* Border sudut */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-[0.5%] -left-[0.2%] z-20 w-3 h-3 border-t-4 border-l-4 border-red-500"></div>
          <div className="absolute -top-[0.5%] -right-[0.2%] z-20 w-3 h-3 border-t-4 border-r-4 border-red-500"></div>
          <div className="absolute -bottom-[0.5%] -left-[0.2%] z-20 w-3 h-3 border-b-4 border-l-4 border-red-500"></div>
          <div className="absolute -bottom-[0.5%] -right-[0.2%] z-20 w-3 h-3 border-b-4 border-r-4 border-red-500"></div>
        </div>

        {/* Icon */}
        <div className="absolute top-[6%] right-[4%]">
          <RecentActorsIcon color="info" />
        </div>

        {/* Konten utama */}
        <div
          key={decryptNik(item?.data?.nik)}
          className="p-1 sm:p-2 rounded-lg mb-0.5 items-center text-white"
        >
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center">
            {/* Gambar */}
            <div id="gambar" className="flex gap-2 items-center">
              <img
                // src={displayBinaryImage(item?.backgroundRes)}
                src={item?.backgroundRes}
                alt="target"
                loading="lazy"
                className="object-cover border rounded w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]"
              />
              <img
                // src={displayBinaryImage(item?.personFaceRes)}
                src={item?.personFaceRes}
                alt="target"
                className="object-cover border rounded w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]"
              />
            </div>

            {/* Informasi Teks */}
            <div
              id="text"
              className="flex flex-col flex-1 text-[10px] sm:text-xs whitespace-nowrap overflow-hidden"
            >
              <div className="capitalize font-semibold truncate text-blue-300">
                {item?.fullName}
              </div>
              <div className="truncate">{decryptNik(item?.nik)}</div>
              <div className="truncate">
                {item?.placeOfBirth +
                  ", " +
                  formatDisplayDate2(item?.dateOfBirth)}
              </div>
              <div className="truncate">
                Similarity: {roundToTwoDecimals(item?.similarity)}%
              </div>
            </div>
          </div>
        </div>

        {/* Waktu Deteksi */}
        <div className="text-[10px] sm:text-xs ml-2 sm:ml-3 pb-1 text-white truncate">
          Terdeteksi: {convertToIndonesianTime(item?.timestamp)}
        </div>
      </div>
    </div>
  );
};

export default BoxTarget;
